export default "<div [class]=\"isLocal ? 'loading-local' : 'loading'\">\n  <mat-spinner [diameter]=\"70\" class=\"preloader\"></mat-spinner>\n</div>\n";